//
import React from 'react'
import AppContext from "../../context/AppContext";
//
import Index from "./recipe-category/Index";
import View from "./recipe-category/View";
import Create from "./recipe-category/Create";
import Update from "./recipe-category/Update";
import NoPage from "../NoPage";

class RecipeCategory extends React.Component {

    static contextType = AppContext;

    /**
     * @return {AppBase}
     */
    app = () => {
        return this.context;
    }

    render = () => {
        let $pages = []
        let $app = this.app()

        $pages.push($app.content.showPage(<Index/>, 'Recipe-Category', 'Index'))
        $pages.push($app.content.showPage(<Create/>, 'Recipe-Category', 'Create'))
        $pages.push($app.content.showPage(<Update/>, 'Recipe-Category', 'Update'))
        $pages.push($app.content.showPage(<View/>, 'Recipe-Category', 'View'))

        return ($pages.join('') === '' ? <NoPage/> : $pages);
    }
}

export default RecipeCategory;